function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPhotoOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.21 20.75h18V4.25h-18v16.5zm18-18h-18a1.5 1.5 0 00-1.5 1.5v16.5a1.5 1.5 0 001.5 1.5h18a1.5 1.5 0 001.5-1.5V4.25a1.5 1.5 0 00-1.5-1.5zM15.585 11a1.125 1.125 0 100-2.25 1.125 1.125 0 000 2.25zm2.625-3.75h-12v6.351l3.334-3.334 3.75 3.75 2.25-2.25 2.666 2.667V7.25zm-12 8.472v2.028h12v-1.195l-2.666-2.666-1.19 1.19.846.845-1.06 1.06-4.596-4.596-3.334 3.334zm13.5 3.528h-15V5.75h15v13.5z",
    fill: props.color
  }));
}

export default SvgIconPhotoOutline;